import { NotificationsContent } from '/src/features/notifications/components/NotificationsContent';
import { NotificationsFilterProvider } from '/src/features/notifications/notifications-filter-context';

// eslint-disable-next-line no-restricted-syntax
export default function NotificationsSettings() {
  return (
    <NotificationsFilterProvider>
      <NotificationsContent />
    </NotificationsFilterProvider>
  );
}
